import React, { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { AnalyticEvents } from '@constants/index';
import { Analytics } from '@services/analytics-service';
import { useRouter, ROUTES } from '../../providers/router';
import { SelectionList } from '../../components/selection-list';
import { Levels } from '../../constants';

export const Categories = () => {
  useEffect(() => {
    Analytics.trackEvent(AnalyticEvents.sarCategoryViewed);
    datadogRum.addAction(AnalyticEvents.sarCategoryViewed);
  }, []);

  const { completeFormStep } = useRouter();

  const handleNextRoute = (dataSubset: any) => {
    completeFormStep(ROUTES.CATEGORIES, dataSubset);
  };

  return <SelectionList level={Levels.Category} handleNextRoute={handleNextRoute} />;
};

export default Categories;
